// extracted by mini-css-extract-plugin
module.exports = {"numBtn":"btn_numBtn__1IM56","btn":"btn_btn__2yQ6D","txt":"btn_txt__2CZKd"};